export type TNativeIIRFilterNode = IIRFilterNode;
